
/**
 * Create by zhixiaping on 2018/10/7
 *
 */
// -----------有关全局提示的vuex
import { Toast } from 'vant'
const actions = {
  showToast (contaxt, toastMsg) {
    if (typeof toastMsg === 'string') {
      Toast({
        message: toastMsg,
        time: 5000
      })
    } else {
      Toast({
        message: toastMsg.msg,
        position: toastMsg.position || 'bottom',
        duration: toastMsg.time || 5000
      })
    }
  }
}
export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/toast.js